/**
 * These are the Global permissions.
 */
/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
export const globalPermissions = {
  FeaturePreview: {
    View: "globalFeaturePreviewCanView"
  },
  AboutPage: {
    View: "globalAboutPageCanView"
  },
  AdministrationPage: {
    View: "globalAdministrationPageCanView"
  },
  CaseSearchPage: {
    View: "globalCaseSearchPageCanView"
  },
  CaseQueuePage: {
    View: "globalCaseQueuePageCanView"
  },
  SubjectSearchPage: {
    View: "globalSubjectSearchPageCanView"
  },
  DashboardPage: {
    View: "globalDashboardPageCanView"
  },
  DeviceManagerPage: {
    View: "globalDeviceManagerPageCanView"
  },
  TelevisionManagerPage: {
    View: "globalTelevisionManagerPageCanView"
  },
  PatientManagerPage: {
    View: "globalPatientManagerPageCanView"
  },
  ProfileDetailsPage: {
    View: "globalProfileDetailsPageCanView"
  },
  AdminTagsPage: {
    View: "globalAdminTagsPageCanView"
  },
  ContentManagementPage: {
    View: "globalContentManagementPageCanView"
  },
  SystemInformationPage: {
    View: "globalSystemInformationPageCanView"
  },
  vCompanion: {
    View: "globalvCompanionPageCanView"
  },
  VCare: {
    View: "globalvCarePageCanView"
  },
  VCIPage: {
    View: "globalVCIPageCanView",
    /**
     * Write a user's coverage (the Team Coverage manager editor). Matches the
     * backend `vciCoverageCanWrite` permission gating coverage `PATCH /user/{userId}`.
     */
    ManageCoverage: "vciCoverageCanWrite"
  },
  TeamChat: {
    /**
     * Use team chat: the backend `teamChatCanUse` permission every chat endpoint
     * requires, alongside the `common.featureFlags.teamChatEnabled` flag.
     */
    Use: "teamChatCanUse"
  }
};
